export default "__VITE_ASSET__5372ef44__"